<script>
export default {
  name: 'UlFormItemDictionary',
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    query: '',
    max: 100,
  }),
};
</script>
<template>
  <div class="ul-form-dictionary">
    <UlFormSelect
      class="ul-form-dictionary__select"
      v-model="module.value"
      :disabled="module.disabled"
      :clearable="!module.require"
      :options="module.options"
      placeholder=""
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
    <UlFormItemBtn
      class="ul-form-dictionary__icon"
      icon="el-icon-plus"
    />
  </div>
</template>
<style lang="scss">
  .ul-form-dictionary {
    display: flex;

    &__select {
      flex: 1;
    }

    &__icon {
      flex-shrink: 0;
    }
  }
</style>
